import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_selectionStart(_this__u8e3s4) {
  var tmp = _this__u8e3s4.native_1.element_1;
  var tmp0_safe_receiver = tmp instanceof HTMLInputElement ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.selectionStart;
}
function get_selectionEnd(_this__u8e3s4) {
  var tmp = _this__u8e3s4.native_1.element_1;
  var tmp0_safe_receiver = tmp instanceof HTMLInputElement ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.selectionEnd;
}
function setSelectionRange(_this__u8e3s4, start, end) {
  var tmp = _this__u8e3s4.native_1.element_1;
  var tmp0_safe_receiver = tmp instanceof HTMLInputElement ? tmp : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.setSelectionRange(start, end);
  }
}
//region block: exports
export {
  get_selectionEnd as get_selectionEnd2du62zn9takrg,
  get_selectionStart as get_selectionStart2vknrfox4u4l8,
  setSelectionRange as setSelectionRange10xzbpb686fcx,
};
//endregion

//# sourceMappingURL=FormattedTextInput.commonHtml.js.mjs.map
